
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'



export default {
components: {
wx,XTextarea,Group
},
data() {
return {
subStatus: true,
popUp: false,
clotheShow: false,
rechargePop: false,
colorShow: false,
flawShow: false,
clotheShowStatus: true,
bagCode:'',
totalAmount:0,
expressAmount:0,
order_no:'',
type:0,
number:0,
order: {
community:{
name:''
},
},
froms:[],
clotheIndex:0,
colorIndex:0,
flawIndex:0,
picIndex:0,
clothes: [],
colors: [],
flaws: [],
expressFee: [],
info:{},
operation:'',
orderGoods:'',
userOrderGoods:[],
phone:'',
collectOrders:[],
}
},
created() {





this.phone = this.$route.params.phone;
this.orderGoods = this.$route.params.orderGoods;
this.collectOrders = this.parseCollectOrders();
if(this.collectOrders.length > 0){
this.clotheShowStatus = false;
this.getUserCollectOrders();
}else if(this.phone){
this.clotheShowStatus = false;
this.getUserCollectOrder();
}else{
this.clotheShowStatus = true;
this.createClotheShow();
}
this.getWashCategoryGoods();
},
mounted(){
this.config();

},
methods: {
getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
synLastUser(index){
if(index > 0){
let row = this.froms[index - 1];
this.froms[index].name = row.name;
this.froms[index].phone = row.phone;
}
},
removeModules(index){
let that = this;
let row = this.froms[index];
if(row.is_package > 0){
that.$func.confirm('确定删除套餐所有衣物吗？','提示',()=>{
that.froms = that.froms.filter(val => Number(val.key) !== Number(row.key));
that.countPrice();
that.$func.showToast('删除成功');
})
}else{
that.$func.confirm('确认删除 ”衣物'+(index+1)+'“ 吗？','提示',()=>{
that.froms.splice(index, 1);
that.countPrice();
that.$func.showToast('删除成功');
})
}
},
openClotheFlaw(index){
this.flawIndex = index;
this.popUp = true;
this.flawShow = true;
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{

that.froms[index].bag_code = res.resultStr.split(',')[1];




},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
async getUserCollectOrder() {
this.$api.getUserCollectOrder({phone:this.phone,orderGoods:this.orderGoods}).then((res)=>{
if(res){

this.clotheShowStatus = false;
this.flawIndex = 0;
this.froms = res.data;
this.countPrice();
}
})
},
parseCollectOrders() {
let collectOrders = this.$route.query.collectOrders || '';
if(!collectOrders){
return [];
}
try {
let rows = JSON.parse(collectOrders);
return Array.isArray(rows) ? rows.filter(item => item.phone && item.orderGoods && item.orderGoods.length > 0) : [];
} catch (e) {
console.log(e);
return [];
}
},
async getUserCollectOrders() {
this.$func.startLoading('请求中...');
try {
let list = [];
for (let item of this.collectOrders) {
let res = await this.$api.getUserCollectOrder({
phone: item.phone,
orderGoods: JSON.stringify(item.orderGoods)
});
if(res && res.data){
list = list.concat(res.data);
}
}
this.clotheShowStatus = false;
this.flawIndex = 0;
this.froms = list;
this.countPrice();
} finally {
this.$func.endLoading();
}
},
getWashCategoryGoods() {
this.$api.getWashCategoryGoods({}).then((res)=>{
if(res){
this.clothes = res.data.goods;

this.expressFee = res.data.expressFee;
this.flaws = res.data.flaw;
if(this.froms.length > 0){
this.countPrice();
}
}
})
},
openClotheShow(index){
this.clotheIndex = index;
this.popUp = true;
this.clotheShow = true;
this.operation = 'edit';
},
createClotheShow(){
this.popUp = true;
this.clotheShow = true;
this.operation = 'add';
},
closePop(){
this.popUp = false;
this.rechargePop = false;
this.clotheShow = false;
this.flawShow = false;
this.clotheIndex = 0;
this.flawIndex = 0;
this.amount = 0;
},
flawSelect(i,title){
let flawId = this.froms[this.flawIndex].flaw_id;
if(flawId){
if(flawId.indexOf(i) > -1){
flawId.splice(flawId.indexOf(i),1);
this.froms[this.flawIndex].flaw_id = flawId;
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
let flaw = this.froms[this.flawIndex].flaw_id;
this.froms[this.flawIndex].flaw = '';
flaw.forEach((item,index)=>{
this.froms[this.flawIndex].flaw += (index == flaw.length-1 ? this.flaws[item].title : this.flaws[item].title+',');
});
if(this.froms[this.flawIndex].flaw_id.length < 1){
this.froms[this.flawIndex].flaw = '选择瑕疵';
}
},
clotheSelect(i){
let row = this.clothes[i];
let key = Date.now();
if(this.operation == 'add'){
if(row.is_package > 0){
let price = Number(row.price/row.wash_num).toFixed(2);
for(var j=0;j<row.wash_num;j++){
this.froms.push({
is_package:1,
key:key,
name:'',
phone:'',
bag_code:'',
remark:'',
clothe_id:row.id,
price:price,
clothe:row.title+'_'+(j+1),
filePath: [],
pics:[],
flaw_id:[],
flaw:'选择瑕疵',
});
}
}else{
this.froms.push({
is_package:0,
key:key,
name:'',
phone:'',
bag_code:'',
remark:'',
clothe_id:row.id,
price:row.price,
clothe:row.title,
filePath: [],
pics:[],
flaw_id:[],
flaw:'选择瑕疵',
});
}
}else{
let item = this.froms[this.clotheIndex];
if(item.is_package > 0){
this.froms = this.froms.filter(val => Number(val.key) !== Number(item.key));
}else{
this.froms.splice(this.clotheIndex, 1);
}
if(row.is_package > 0){
let price = Number(row.price/row.wash_num).toFixed(2);
for(var j=0;j<row.wash_num;j++){
this.froms.push({
is_package:1,
key:key,
name:item.name,
phone:item.phone,
bag_code:'',
remark:item.remark,
clothe_id:row.id,
price:price,
clothe:row.title+'_'+(j+1),
filePath: item.filePath,
pics:item.pics,
});
}
}else{
this.froms.push({
is_package:0,
key:key,
name:item.name,
phone:item.phone,
bag_code:'',
remark:item.remark,
clothe_id:row.id,
price:row.price,
clothe:row.title,
filePath: item.filePath,
pics:item.pics,
});
}
}
this.countPrice();
this.closePop();
},
countPrice(){
let that = this,exAmount = 0,number1=0;
number1 = this.froms.filter(item => item.is_package == 0).length;
console.log('number1',number1);
if(number1 > 0){
for (let item of this.expressFee) {
if(item.num >= number1){
exAmount = item.amount;
break;
}
}
}
this.number = this.froms.length;
this.expressAmount = exAmount;
this.totalAmount = 0;
this.froms.forEach((item,index)=>{
that.totalAmount += Number(item.price);
})
this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
},
submit() {
let that = this;
if(!this.subStatus){
return false;
}
that.$func.confirm('确认提交？','提示',()=>{
this.$func.startLoading('请求中...');
that.$api.createWashOrder({goods:JSON.stringify(that.froms)}).then((res)=>{
if(res){
that.$func.endLoading();
if(res.data.amount > 0){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
that.subStatus = true;
setTimeout(()=>{
if(that.clotheShowStatus){
window.location.reload();
}else{
that.$router.replace({name:'collectUser',params:{phone:that.phone}});
}
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}else{
that.$func.showToast('提交成功');
that.subStatus = true;

setTimeout(()=>{
if(that.clotheShowStatus){
window.location.reload();
}else{
that.$router.replace({name:'collectUser',params:{phone:that.phone}});
}
},300);
}
}
})
})

},
config(){


let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"scanQRCode"
]
});
}
})
},
uploadFile(index){
let that = this;
this.picIndex = index;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
if(res){
that.froms[that.picIndex].filePath.push(res.data.pathName);
that.froms[that.picIndex].pics.push(res.data.saveName);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(i,index) {
wx.previewImage({
current: this.froms[i].filePath[index],
urls: [this.froms[i].filePath[index]]
});
},
delImg(i,index){
this.froms[i].filePath.splice(index,1);
this.froms[i].pics.splice(index,1);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/createWashOrder.vue